<template>
  <div
    class="container-fluid"
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >
    <b-card
      header="Státuszok"
      border-variant="secondary"
      header-bg-variant="secondary"
      header-text-variant="white"
      class="text-center mt-2"
    >
      <div class="col-sm-12 mx-auto">
        <div class="row">
          <!-- // NEW -->
          <b-button
            size="sm"
            variant="primary"
            @click="$router.push({ name: 'StatusNew' })"
            ><b-icon-plus-circle></b-icon-plus-circle>
            Új státusz hozzáadása
          </b-button>
        </div>
      </div>

      <!-- // TABLE -->
      <div class="mt-3">
        <table class="table labelsize table-striped text-right">
          <thead>
            <tr>
              <th class="text-left">Megnevezés</th>
              <th>edit</th>
              <th>del</th>
            </tr>
          </thead>
          <tbody is="draggable" group="people" @end="onEnd" :list="list" tag="tbody">
            <tr  v-for="(element, index) in list" :key="element.id">
              <td class="text-left">{{element.megnevezes}}</td>
              <td>
                <b-button
                  size="sm"
                  @click="
                    $router.push({
                      name: 'StatusNew',
                      params: { id: element.id }
                    })
                  "
                  variant="outline-success"
                  class="mr-1"
                ><b-icon-pencil></b-icon-pencil>
                </b-button>
              </td>
              <td>
                <b-button
                  size="sm"
                  @click="showMsgBoxTwo(element.id)"
                  variant="outline-danger"
                  class="mr-1"
                  ><b-icon-trash></b-icon-trash>
                </b-button>              
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- // TABLE OLD -->
      <div class="mt-3" hidden>
        <b-table small striped hover :items="list" :fields="fields" :key="list.id">
          
          <!-- // EDIT -->
          <template v-slot:cell(edit)="row">
            <b-button
              size="sm"
              @click="
                $router.push({
                  name: 'StatusNew',
                  params: { id: row.item.id }
                })
              "
              variant="outline-success"
              class="mr-1"
            ><b-icon-pencil></b-icon-pencil>
            </b-button>
          </template>

          <!-- // DELETE -->
          <template v-slot:cell(del)="row" class="mb-1">
            <b-button
              size="sm"
              @click="showMsgBoxTwo(row.item.id)"
              variant="outline-danger"
              class="mr-1"
              ><b-icon-trash></b-icon-trash>
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      boxTwo: '',
      token: localStorage.usertoken,
      auth: '',
      userType : decoded.usertype,
      list: [],
      fields: [
        {
          key: 'id',
          label: 'Id',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'megnevezes',
          label: 'Magnevezés',
          sortable: true,
          sortDirection: 'desc'
        },
        { key: 'edit', sortable: true },
        { key: 'del', sortable: true }
      ]
    }
  },
  methods: {
    onEnd: function(evt) { 
      for(let el in this.list) {
        this.list[el].order = el
      }
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.list = this.list
        axios
          .post('http://'+process.env.ROOT_API+'/status/ordersave', { payload })
          .then(res => {
            //this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },      
    deleteElement: function (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios
          .post('http://'+process.env.ROOT_API+'/status/delete', { payload })
          .then(res => {
            this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    showMsgBoxTwo (reqData) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Biztos, hogy törölni akarod? ', {
          title: 'Megerősítés',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) this.deleteElement(reqData)
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadList () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        axios
          .post('http://'+process.env.ROOT_API+'/status/getlist', { payload })
          .then(res => {
            this.list = res.data
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    this.loadList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Status.vue